import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="email-tags"
// Simple email tags input without Choices.js
export default class extends Controller {
  static targets = ["input", "hiddenField", "tagsContainer", "submitButton"];

  static EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  connect() {
    this.emails = [];
  }

  handleKeydown(event) {
    // Separators: Enter, Tab, comma, semicolon
    if (
      event.key === "Enter" ||
      event.key === "Tab" ||
      event.key === "," ||
      event.key === ";"
    ) {
      const value = this.inputTarget.value.trim();
      if (value) {
        event.preventDefault();
        this.addEmail(value);
      } else if (event.key === "," || event.key === ";") {
        // Prevent typing separator when input is empty
        event.preventDefault();
      }
    }

    // Allow backspace to remove last tag when input is empty
    if (
      event.key === "Backspace" &&
      this.inputTarget.value === "" &&
      this.emails.length > 0
    ) {
      this.removeEmail(this.emails.length - 1);
    }
  }

  handlePaste(event) {
    event.preventDefault();
    const pastedText = event.clipboardData.getData("text");
    const emails = pastedText.split(/[,;\s]+/).filter((e) => e.trim());
    emails.forEach((email) => this.addEmail(email.trim()));
  }

  addEmail(email) {
    if (this.emails.includes(email)) {
      // Duplicate - just clear input
      this.inputTarget.value = "";
      return;
    }

    this.emails.push(email);
    this.renderTags();
    this.updateHiddenField();
    this.updateSubmitButton();
    this.inputTarget.value = "";
    this.inputTarget.focus();
  }

  removeEmail(index) {
    this.emails.splice(index, 1);
    this.renderTags();
    this.updateHiddenField();
    this.updateSubmitButton();
    this.inputTarget.focus();
  }

  isValidEmail(email) {
    return this.constructor.EMAIL_REGEX.test(email.trim());
  }

  renderTags() {
    // Clear existing tags (but keep the input)
    const existingTags =
      this.tagsContainerTarget.querySelectorAll(".email-tag");
    existingTags.forEach((tag) => tag.remove());

    // Add tags before the input
    this.emails.forEach((email, index) => {
      const isValid = this.isValidEmail(email);
      const tag = document.createElement("span");
      tag.className = `email-tag ${isValid ? "is-valid" : "is-invalid"}`;
      tag.innerHTML = `
        ${this.escapeHtml(email)}
        <button type="button" class="email-tag-remove" data-index="${index}">&times;</button>
      `;
      tag.querySelector("button").addEventListener("click", () => {
        this.removeEmail(index);
      });
      this.tagsContainerTarget.insertBefore(tag, this.inputTarget);
    });
  }

  escapeHtml(text) {
    const div = document.createElement("div");
    div.textContent = text;
    return div.innerHTML;
  }

  updateHiddenField() {
    this.hiddenFieldTarget.value = this.emails.join(", ");
  }

  updateSubmitButton() {
    if (!this.hasSubmitButtonTarget) return;

    const hasEmails = this.emails.length > 0;
    const allValid = this.emails.every((email) => this.isValidEmail(email));

    this.submitButtonTarget.disabled = !(hasEmails && allValid);
  }
}
